












































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { AppState } from '@/store/types/app';
import { pinYinParser } from '@/util/parser';
import Sight from '@/components/Sight.vue';

const namespace: string = 'app';

@Component({
  components: {
    Sight
  }
})
export default class Banner extends Vue {
  private parser = pinYinParser;

  @Action('setSight', { namespace }) private setSight: any;
  @Getter('sight', { namespace }) private sight: any;

  public mounted () {
    this.measureSightSize();

    window.addEventListener('resize', this.measureSightSize);
  }

  private measureSightSize () {
    const sightContainer: any = this.$refs.sightContainer;

    if (sightContainer.clientWidth > 840) {
      this.setSight({
        width: sightContainer.clientWidth,
        height: sightContainer.clientHeight,
        spot: {
          x: sightContainer.clientWidth / 2.0 + 140,
          y: sightContainer.clientHeight / 2.0 + 50
        }
      });
    } else {
      this.setSight({
        width: sightContainer.clientWidth,
        height: sightContainer.clientHeight,
        spot: {
          x: sightContainer.clientWidth + 50,
          y: sightContainer.clientHeight / 2.0 + 50
        }
      });
    }
  }
}
